<template>
  <v-container class="legal-index">
    <v-layout row>
      <v-flex class="my-5">
        <H1>
          Legal Notices and Disclaimer of Liability
        </H1>
        <p>
          A list of legal documents to understand the site.
        </p>
        <v-list>
          <v-list-tile
            v-for="item in menu"
            :key="item.url"
            @click="handleLink(item.url)"
          >
            <v-list-tile-action>
              <v-icon color="primary">book</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.legal-index {
  display: inherit;
}
</style>

<script>
export default {
  name: 'legalIndex',
  data () {
    return {
      menu: [
        { title: 'TD Bank Goup', url: 'https://www.td.com/to-our-customers/' }
        // { title: 'TD Lab Terms of Service', url: '/legal/terms-of-service' },
        // { title: 'TD Lab Privacy and Security', url: '/legal/privacy-and-security' }
      ]
    }
  },
  methods: {
    handleLink (url) {
      let urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$' + // fragment locator
        '',
        'i' + // string to match
        '')
      const isUrl = urlPattern.test(url)

      if (isUrl) {
        window.open(url)
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>
